<template>
  <div class="production-sx noFilter">
    <pageTitle class="getHeader" :title="title" :corner="corner" @cornerAdd="cornerAdd"></pageTitle>
    <div class="typeWrap">
      <van-tabs class="tabs" v-model="active" swipeable @change="change" color="#2AB774">
        <van-tab v-for="(s, t) in productList" :key="s.entProductId" :title="s.productName">
          <div class="pannel">
            <div class="fixedBox">
              <p class="showTotal">共计：{{ total }} 条数据</p>
            </div>
            <div class="listBox">
              <p class="showTips" v-if="list.length === 0">{{ noDataText }}</p>
              <van-list v-model="loading" :finished="finished" @load="onLoad"
                        :immediate-check="false">
                <transition-group tag="div" name="list">
                  <div v-for="(v, i) in list" :key="'production_'+i"
                       class="item list-item rippleMagic"
                       @click="jumpTo(v)">
                    <p class="item-title">
                      <span class="left">{{ i + 1 }}. {{ v.entName }}</span>
                      <van-button round type="primary" size="small">查看</van-button>
                      <!-- <van-button round type="danger" size="small" @click="showPrint(v, i)">删除</van-button> -->
                    </p>
                    <div class="item-content">
                      <div class="info">
                        <p class="left">
                          <span>生产记录:</span>
                          <span>{{ v.produceName }}</span>
                        </p>
                      </div>
                      <div class="info">
                        <p class="left">
                          <span>产品名称:</span>
                          <span>{{ v.productName }}</span>
                        </p>
                      </div>
                      <div class="info">
                        <p class="left">
                          <span>创建时间:</span>
                          <span>{{ v.produceTime }}</span>
                        </p>
                      </div>
                      <div class="info">
                        <p class="left">
                          <span>企业名称:</span>
                          <span>{{ v.entName }}</span>
                        </p>
                      </div>
                      <div class="info">
                        <p class="left">
                          <span>所属地区:</span>
                          <span>{{ v.areaPath }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </van-list>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>

import { pageProduce } from '@/api/production'
import { pageEnterpriseProduct } from '@/api/dictionary'
import TimerFilter from '@/components/TimeFilter/TimerFilter'
import AreaFilter from '@/components/Search/project-search'

export default {
  name: 'production-sx',
  components: { TimerFilter, AreaFilter },
  data () {
    return {
      title: '产品生产记录',
      corner: '新增',
      active: 0,
      list: [],
      loading: true,
      finished: false,
      total: 0,
      pageNum: 1,
      pageSize: 20,
      noDataText: '',
      startTime: '',
      endTime: '',
      entId: '',
      entName: '',
      isShow: '',
      productName: '',
      entProductId: '',
      productList: [],
    }
  },
  created () {
    this.entId = this.$route.query.entId || '';
    this.entName = this.$route.query.entName || '';
    // userType 游客:-1  管理员:0  企业用户:1  监管用户:2  企业员工:3  企业微信登录:4
    let userType = this.$store.state.userType
  },
  async mounted () {
    let entProductId = await this.getPageEnterpriseProduct();
    this.onLoad(entProductId);
  },
  methods: {
    cornerAdd () { // 右上角点击
      this.$router.push({
        path: 'production-addpro',
        query: {
          entId: this.entId || '',
          entName: this.entName || ''
        }
      })
    },
    getPageEnterpriseProduct () { // 获取产品种类
      return pageEnterpriseProduct({
        entId: this.entId,
        productName: this.productName,
        pageNum: 1,
        pageSize: 300,
      }).then(res => {
        if (res.state === 'Y') {
          this.productList = res.rows.map(s => {
            return { productName: s.productName, entProductId: s.entProductId }
          });
          let entProductId = res.rows[0] && res.rows[0].entProductId || '';
          return entProductId;
        } else {
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    change (data) { // 切换产品
      this.entProductId = this.productList[data] && this.productList[data].entProductId || '';
      this.changeList();
    },
    onLoad (entProductId) {// 获取别表
      pageProduce({
        areaCodeCity: this.$store.state.areaCodeCity || '',
        areaCodeDistrict: this.$store.state.areaCodeDistrict || '',
        areaCodeSubdistrict: this.$store.state.areaCodeSubdistrict || '',
        entName: this.entName,

        entProductId: entProductId || this.entProductId,
        pageNum: this.pageNum++,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.state === 'Y') {
          let rows = res.rows
          this.total = parseInt(res.total)

          if (rows.length === 0) {
            this.noDataText = '暂无数据！'
            this.loading = false
            this.finished = true
            if (this.pageNum === 2) {
              this.list = []
            }
            return
          }
          this.list.push(...rows.map(v => {
            return v
          }))
          this.loading = false
          if (rows.length < this.pageSize || this.list.length === this.total) {
            this.finished = true
          }
        } else {
          this.loading = false
          this.finished = true
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.loading = false
        this.finished = true
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    changeList () { // 本页筛选公共方法
      this.loading = true;
      this.pageNum = 1;
      this.total = 0;
      this.list = [];
      this.noDataText = '';
      if(this.finished) {
        this.finished = false;
      }
      this.onLoad();
    },
    jumpTo (obj) {
      this.$router.push({
        path: 'production-detail',
        query: {
          produceId: obj.produceId,
        },
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.production-sx {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .typeWrap {
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    /deep/ .van-tabs__wrap {
        flex: 0 0 10vw;
        height: 10vw;

        .van-tab {
          font-size: 4vw;
        }
      }

    /deep/ .van-tabs__content {
        flex: 1;
        overflow: hidden;

        .van-tab__pane {
          height: 100%;
          overflow: hidden;
        }
      }
  }

  .pannel {
    flex: 1;
    position: relative;
    height: 100%;
    display: flex;
    overflow: hidden;

    .fixedBox {
      position: fixed;
      top: 20vw;
      left: 0;
      z-index: 9;
      width: 100%;

      .filterBox {
        display: flex;
        padding: 2vmin;
        font-size: $font-icon-middle;
        background: $color-white;

        .item {
          flex: 1;
          height: 10vmin;
          line-height: 10vmin;
          margin: 0 2vmin;
          background: $color-light-white;
          color: $color-gray;
          border-radius: 6px;
          text-align: center;

          &.active {
            background: $color-hover;
            color: $color-white;
          }
        }
      }

      .showTotal {
        height: 8vmin;
        line-height: 8vmin;
        padding: 0 15px;
        background: rgb(239, 239, 244);
        font-size: 4vmin;
        text-align: left;
      }
    }

    .listBox{
      margin-top: 8vw;
    }

    .showTips {
      line-height: 10vmin;
      text-align: center;
      font-size: 4vmin;
      background: #fff;
    }
  }
}
</style>
